import React from 'react'
import { FormControl, InputLabel, OutlinedInput } from '@mui/material'

const DateOutlinedInput = ({ id, label, width, defaultValue, value, onChange, color }) => {
  return (
    <FormControl className="formcontrol" variant="outlined" size="small" sx={{ width: width || 'auto' }} color={color || "primary"}>
        <InputLabel shrink htmlFor={id}>{label}</InputLabel>
        <OutlinedInput id={id} label={label} size="small" type="date" defaultValue={defaultValue} value={value} onChange={onChange} autoComplete="off"style={{backgroundColor:'#fff'}} />
    </FormControl>
  );
}

export default DateOutlinedInput